<samweb-toolbar
   [brickInstanceId]="brickInstanceId"
   [toolbarId]="'toolbar'"
   [showVertical]="showVertical$ | async"
></samweb-toolbar>
